import { Link } from "react-router-dom";
import TeamBadge from "@/components/base/TeamBadge";
import StatusBadge from "@/components/base/StatusBadge";
import { sportNames, type SportEvent } from "@/mocks/events";

export default function EventCard({ event }: { event: SportEvent }) {
  const hasScore = event.status !== "upcoming";

  return (
    <article className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-500/50 hover:bg-background-200/70 md:p-5">
      <header className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 overflow-hidden">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-secondary-500/15 text-secondary-300">
            <i className="ri-trophy-line text-[13px]" />
          </span>
          <span className="truncate text-xs text-foreground-500">
            {event.league} · {event.round}
          </span>
        </div>
        <StatusBadge status={event.status} />
      </header>

      <div className="mt-4 flex items-center justify-between gap-2">
        <div className="flex flex-col items-center gap-2 w-[42%]">
          <TeamBadge team={event.home} size={46} />
          <span className="text-center text-xs font-medium leading-tight text-foreground-800">
            {event.home.name}
          </span>
        </div>

        <div className="flex flex-col items-center gap-1">
          {hasScore ? (
            <div className="font-heading text-2xl font-bold tracking-tight text-foreground-900 md:text-3xl">
              <span className={event.status === "live" ? "text-primary-400" : ""}>
                {event.homeScore}
              </span>
              <span className="mx-2 text-foreground-400">:</span>
              <span className={event.status === "live" ? "text-primary-400" : ""}>
                {event.awayScore}
              </span>
            </div>
          ) : (
            <div className="font-heading text-lg font-bold text-foreground-500">
              VS
            </div>
          )}
          <span className="text-[11px] text-foreground-500 whitespace-nowrap">
            {event.progress}
          </span>
        </div>

        <div className="flex flex-col items-center gap-2 w-[42%]">
          <TeamBadge team={event.away} size={46} />
          <span className="text-center text-xs font-medium leading-tight text-foreground-800">
            {event.away.name}
          </span>
        </div>
      </div>

      <footer className="mt-4 flex items-center justify-between gap-3 border-t border-background-200 pt-3">
        <div className="flex flex-col gap-1 overflow-hidden">
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-time-line" />
            {event.time}
          </span>
          <span className="flex items-center gap-1.5 truncate text-xs text-foreground-500">
            <i className="ri-map-pin-2-line" />
            {event.venue}
          </span>
        </div>
        <Link
          to={`/live/${event.id}`}
          className="flex items-center gap-1.5 rounded-md bg-primary-500 px-3.5 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
        >
          <i
            className={
              event.status === "ended"
                ? "ri-play-circle-line"
                : "ri-live-line"
            }
          />
          {event.status === "ended" ? "看回放" : event.status === "live" ? "看直播" : "预约"}
        </Link>
      </footer>

      <span className="sr-only">{sportNames[event.sport]}</span>
    </article>
  );
}